import {
  ADD_CUSTOMER_FAIL,
  ADD_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAIL,
  DELETE_CUSTOMER_SUCCESS,
  EXPORT_CUSTOMER_FAIL,
  EXPORT_CUSTOMER_SUCCESS,
  GET_CUSTOMER_DETAILS_FAIL,
  GET_CUSTOMER_DETAILS_SUCCESS,
  GET_CUSTOMER_FAIL,
  GET_CUSTOMER_SELECT_LISTING_FAIL,
  GET_CUSTOMER_SELECT_LISTING_SUCCESS,
  GET_CUSTOMER_SUCCESS,
  RESET_CUSTOMER_STATE,
  UPDATE_CUSTOMER_FAIL,
  UPDATE_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_VOUCHERS_FAIL,
  ADD_CUSTOMER_VOUCHERS_SUCCESS,
  ADD_CUSTOMER_POINTS_FAIL,
  ADD_CUSTOMER_POINTS_SUCCESS,
  RESET_CUSTOMER_ATTACHMENT_STATE,
} from "./actionTypes"

const INIT_STATE = {
  customer: [],
  customerDetails: [],
  addCustomer: [],
  editCustomer: [],
  delCustomer: [],
  exportCustomer: [],
  addCustomerPoint: [],
  addCustomerVouchers: [],
}

const Customer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        customer: action.payload,
      }

    case GET_CUSTOMER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CUSTOMER_SELECT_LISTING_SUCCESS:
      return {
        ...state,
        customerSelectListing: action.payload,
      }

    case GET_CUSTOMER_SELECT_LISTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_CUSTOMER_DETAILS_SUCCESS:
      return {
        ...state,
        customerDetails: action.payload,
      }

    case GET_CUSTOMER_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_CUSTOMER_SUCCESS:
      return {
        ...state,
        customerDetails: action.payload.data,
        addCustomer: action.payload,
      }

    case ADD_CUSTOMER_FAIL:
      return {
        ...state,
        error: action.payload,
        addCustomer: action.payload,
      }

    case UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        customerDetails: action.payload.data,
        editCustomer: action.payload,
      }

    case UPDATE_CUSTOMER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        delCustomer: action.payload,
      }

    case DELETE_CUSTOMER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case EXPORT_CUSTOMER_SUCCESS:
      return {
        ...state,
        exportCustomer: action.payload,
      }

    case EXPORT_CUSTOMER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_CUSTOMER_VOUCHERS_SUCCESS:
      return {
        ...state,
        addCustomerVouchers: action.payload,
      }
    case ADD_CUSTOMER_VOUCHERS_FAIL:
      return {
        ...state,
        error: action.payload,
        addCustomerVouchers: action.payload,
      }
    case ADD_CUSTOMER_POINTS_SUCCESS:
      return {
        ...state,
        addCustomerPoint: action.payload,
      }
    case ADD_CUSTOMER_POINTS_FAIL:
      return {
        ...state,
        error: action.payload,
        addCustomerPoint: action.payload,
      }
    case RESET_CUSTOMER_STATE:
      return {
        ...state,
        addCustomer: [],
        customerDetails: [],
        editCustomer: [],
        delCustomer: [],
        exportCustomer: [],
        addCustomerPoint: [],
        addCustomerVouchers: [],
        error: []
      }
    case RESET_CUSTOMER_ATTACHMENT_STATE:
      return {
        ...state,
        exportCustomer: [],
        error: []
      }
    default:
      return state
  }
}

export default Customer
